/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_Skip_BtnInputs */

const vi_einvoice_pending_skip_btn = /** @type {(inputs: Einvoice_Pending_Skip_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xuất`)
};

/**

* @param {Einvoice_Pending_Skip_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_skip_btn = /** @type {((inputs?: Einvoice_Pending_Skip_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_Skip_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_skip_btn(inputs)
});